const getLastThreshold = (widgetProps = [], formFile) => {
  let threshold = 3
  const formFileKeys = Object.keys(formFile)
  if (formFileKeys.length > 0) {
    const checkCurrentUploadedFile = widgetProps?.filter(x => formFile[x.id])
    let tempThreshold = 0
    checkCurrentUploadedFile.forEach(form => {
      const [, count] = form?.id?.split('-') || []
      const curCount = parseInt(count, 10) || 0
      tempThreshold = curCount > tempThreshold ? curCount : tempThreshold
      threshold = tempThreshold > threshold ? tempThreshold : threshold
    })
  }
  return threshold
}

export default getLastThreshold
